module.exports = __webpack_public_path__ + "static/media/organization.5e4f0b74.svg";